import React from 'react';
import { css } from '@emotion/react';
import FeaturesIcon from '$/images/1_Features.svg';
import CustomersIcon from '$/images/3_Customer_stories.svg';
import ThinkificIcon from '$/images/Thinkific_logo.svg';
import HubspotIcon from '$/images/logos/hubspot.svg';
import ZoomIcon from '$/images/logos/zoom.svg';
import EwebinarIcon from '$/images/favicon.svg';
import IntegrationsIcon from '$/images/16_Integration.svg';
import config from '$/config';

const ProductMenu: React.FC<{ target?: string }> = ({ target }): JSX.Element => {
  const SubMenuList = [
    {
      mainTitle: 'Discover',
      textColor: 'teal-1',
      bgColor: 'bg-teal-8',
      children: [
        {
          title: 'Features',
          description: 'Live chat, real-time interactions, and more features that make us unique.',
          icon: <img src={FeaturesIcon} />,
          link: `${config.URL_MARKETING_SITE}/features`,
        },
        {
          title: 'Integrations',
          description: 'Works with your favorite CRMs, marketing solutions, Zapier + more.',
          icon: <img src={IntegrationsIcon} />,
          link: `${config.URL_MARKETING_SITE}/integrations`,
        },
        {
          title: 'Customer stories',
          description: `Don’t take our word for it. See what our customers say.`,
          icon: <img src={CustomersIcon} />,
          link: `${config.URL_MARKETING_SITE}/customers`,
        },
      ],
    },
    {
      mainTitle: 'Top integrations',
      textColor: 'coral-1',
      bgColor: 'bg-coral-4',
      children: [
        {
          title: 'Zoom',
          description: 'Repurpose your Zoom recordings as eWebinars with one click.',
          icon: <img src={ZoomIcon} />,
          link: `${config.URL_MARKETING_SITE}/get/zoom-and-ewebinar`,
          target: '_blank',
        },
        {
          title: 'Thinkific',
          description: 'Sell your courses 24/7 and send attendees directly to your check out.',
          icon: <img src={ThinkificIcon} />,
          link: `${config.URL_MARKETING_SITE}/get/thinkific-and-ewebinar`,
          target: '_blank',
        },
        {
          title: 'Hubspot',
          description: 'Create leads and track webinar attendance with timeline events.',
          icon: <img src={HubspotIcon} />,
          link: `${config.URL_MARKETING_SITE}/integrations/hubspot`,
          target: '_blank',
        },
      ],
    },
  ];
  return (
    <section
      className='md:absolute left-0 rounded-sm hidden bg-white text-xs md:text-sm menu-sub'
      css={css`
        width: 640px;
      `}
    >
      <div className='flex md:justify-between md:px-2 md:pt-6 md:pb-2 pt-4'>
        {SubMenuList.map((item, index) => {
          const itemChilds = item.children as any;
          return (
            <div className='md:w-1/2 text-left md:px-2 col-sub' key={index}>
              <h6 className={`text-sm text-${item.textColor} pl-4 md:pl-16 uppercase font-medium`}>
                {item.mainTitle}
              </h6>
              <ul className='my-2'>
                {itemChilds.map((itemChild: any, indexChild: number) => {
                  return (
                    <li key={indexChild}>
                      <a
                        href={itemChild.link}
                        target={target || itemChild.target}
                        className={`text-gray-28 itemSubmenu flex normal-case no-underline items-center md:items-start md:p-4 py-2 px-4 mr-0 transition-100 rounded-lg hover:${item.bgColor}`}
                      >
                        {/* icon */}
                        <i className='items-center flex mr-4 flex-none w-10 h-10 rounded-full bg-gray-300 p-2'>
                          {itemChild.icon}
                        </i>
                        <div>
                          <h6 className='md:mb-2'>{itemChild.title}</h6>
                          <p className='leading-normal hidden md:block description'>
                            {itemChild.description}
                          </p>
                        </div>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
      <div className='text-left bg-gray-light flex mt-2 md:px-4 md:py-4 py-2'>
        <a
          href='//ilove.ewebinar.com/webinar/15-minute-ewebinar-walkthrough-and-demo-150'
          className='col-sub md:w-1/2 text-gray-28 flex normal-case no-underline items-center md:items-start md:p-4 py-2 px-4 transition-100 rounded-lg hover:bg-teal-8'
          target='_blank'
        >
          {/* icon */}
          <i className='mr-4 flex-none w-8 h-8 rounded-full bg-gray-300 block p-2'>
            <img src={EwebinarIcon} className='w-full' />
          </i>
          <div>
            <h6 className='md:mb-2 whitespace-no-wrap'>Join a demo</h6>
            <p className='leading-normal description hidden md:block'>
              Experience an eWebinar for yourself. We think you’ll be delighted!
            </p>
          </div>
        </a>
      </div>
    </section>
  );
};

export default ProductMenu;
